<template>
	<form @submit.prevent="updateVehicle()" class="mb-5">
		<h1 class="custom-dark-text custom-rounded-15 shadow-lg py-3">
			Edit Vehicle
		</h1>
		<div class="row">
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="vehicleType"
					label="Vehicle Type"
					type="text"
					v-model="vehicle.vehicleType"
					class="form-control form-control-lg dashInput"
					rules="required|min:3|max:40"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="seatingCapacity"
					label="Seating Capacity"
					type="number"
					:min="0"
					v-model="vehicle.seatingCapacity"
					class="form-control form-control-lg dashInput"
					rules="required"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mt-2 mb-4">
				<BaseButton
					class="btn btn-primary form-control"
					type="submit"
					label="Update"
					:disabled="formState.disable"
					:loading="formState.isLoading"
				/>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import BaseInput from "@/components/BaseInput";
	import BaseButton from "@/components/BaseButton";
	import toast from "@/config/toast";

	export default {
		name: "VehicleEdit",
		components: {
			BaseInput,
			BaseButton,
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");

			const router = useRouter();
			const vehicle = reactive({
				vehicleType: null,
				seatingCapacity: 0,
			});

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [],
			});

			if (!store.state.auth.isAuth) router.push({ name: "Login" });
			if (!masterStore.state.data?.vehicleType || !masterStore.state.editId)
				masterStore.methods.changeComponent("table");

			vehicle.vehicleType = masterStore.state.data?.vehicleType;
			vehicle.seatingCapacity = masterStore.state.data?.seatingCapacity;

			const updateVehicle = async () => {
				try {
					await API.privateRequest.patch(
						`vehicles/${masterStore.state.editId}`,
						vehicle,
					);
					toast.success("Vehicle Updated!");
					masterStore.methods.setId("edit", null);
					masterStore.methods.changeComponent("table");
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			//? checking conditions to enable or disable form login button
			const checkForm = () => {
				let inValLength = validation.invalid.length;

				if (inValLength) {
					formState.disable = true;
				} else formState.disable = false;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// event handler for valError event
			const valError = (data) => {
				toast.error(`${data.field} is required`, true);
				setFormVal(data);
				validation.invalid = [...validation.invalid, data];
				checkForm();
			};

			const valSuccess = (data) => {
				setFormVal(data);
				validation.valid = [...validation.valid, data];
				checkForm();
			};

			return {
				vehicle,
				updateVehicle,
				valError,
				valSuccess,
				formState,
			};
		},
	};
</script>
